import { createWebHistory, createRouter } from "vue-router"

const Home = () => import("../pages/Home.vue")
const Download = () => import("../pages/Download.vue")
const Leaderboards = () => import("../pages/Leaderboards.vue")
const LeaderboardsRace = () => import("../pages/Leaderboard.vue")
const LiveMap = () => import("../pages/LiveMap.vue")
const Guide = () => import("../pages/Guide.vue")
const PageNotFound = () => import("../pages/404.vue")
const Challenges = () => import("../pages/Challenges.vue")
const Additional = () => import("../pages/Additional.vue")
const CarDetails = () => import("../pages/CarDetails.vue")
const Drivers = () => import("../pages/Drivers.vue")
const Driver = () => import("../pages/Driver.vue")
const Crews = () => import("../pages/Crews.vue")
const Crew = () => import("../pages/Crew.vue")
const Carlist = () => import("../pages/Carlist.vue")
const Discord = () => import("../pages/Discord.vue")
const ResendActivation = () => import("../pages/ResendActivation.vue")
const bugReport = () => import("../pages/bugReport.vue")
const Rotation = () => import("../pages/Rotation.vue")
const Event = () => import("../pages/Event.vue")
const Liveries = () => import("../pages/Liveries.vue")
const DonateReturn = () => import("../pages/DonateReturn.vue")
const ChallengeOverlay = () => import("../pages/ChallengeOverlay.vue")

const routes = [
  {
    path: "/premium",
    name: "Premium",
    component: Home,
    meta: {
      requireAuth: false
    }
  },
  {
    path: "/carlist",
    name: "Carlist",
    component: Carlist,
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/login",
    name: "Login",
    component: Home,
    meta: {
      requireAuth: false
    }
  },
  {
    path: "/redeemcode",
    name: "RedeemCode",
    component: Home,
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/discord",
    name: "Discord",
    component: Discord,
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/overlay/challenge/:name",
    name: "ChallengeOverlay",
    component: ChallengeOverlay,
    meta: {
      requireAuth: false
    }
  },
  {
    path: "/rotations",
    name: "Rotations",
    component: Rotation,
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/car/:hash",
    name: "Car Dialog",
    component: CarDetails,
    meta: {
      requireAuth: false
    }
  },
    {
      path: "/",
      name: "Home",
      component: Home,
      meta: {
        requireAuth: false
      }
    },
    {
      path: "/challenges/:year?/:week?",
      name: "Challenges",
      component: Challenges,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/download",
      name: "Download",
      component: Download,
      meta: {
        requireAuth: false
      }
    },
    {
      path: "/leaderboards/:type/:active?/:class?",
      name: "Leaderboards",
      component: Leaderboards,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/leaderboards",
      name: "Leaderboards ",
      component: Leaderboards,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/leaderboard/:id/:page/:pu/:class?",
      name: "Leaderboards race",
      component: LeaderboardsRace,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/leaderboard/:id/',
      meta: {
        requireAuth: true
      },
      redirect: to => {
        return to.path + "/1/pu"
      }
    },
    {
      path: "/drivers",
      name: "Drivers",
      component: Drivers,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/driver/:name/:tab?/:race_id?",
      name: "Driver",
      component: Driver,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/crews",
      name: "Crews",
      component: Crews,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/crew/headquarters/:id",
      name: "Crew",
      component: Crew,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/livemap',
      name: "Live Map",
      component: LiveMap,
      meta: {
        requireAuth: false
      }
    },
    {
      path : '/guide',
      name: "Guide",
      component: Guide,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/additional',
      name: "Additional Content",
      component: Additional,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/reset/:token',
      name: "Reset",
      component: Home,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/confirm/:token',
      name: "Confirm",
      component: Home,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/resend-activation',
      name: "Resend Activation",
      component: ResendActivation,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/bugreport',
      name: "Bug Report",
      component: bugReport,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/liveries',
      name: "Liveries",
      component: Liveries,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/event/:name',
      name: "Community Event",
      component: Event,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/minecraft',
      name: "Minecraft",
      beforeEnter: () => {
        window.location.replace('https://nightcrafterz.net/')
        return false
      }
    },
    {
      path: '/donate-return',
      name: "Donate Return",
      component: DonateReturn,
      meta: { requireAuth: false }
    },
    { path: "/404", name: "Page Not Found", component: PageNotFound },
    {
      path: "/:pathMatch(.*)*", name: "PageNotFound2",
      redirect: to => {
        return "/404"
      }
    }
  ]
  
  const router = createRouter({
    history: createWebHistory(),
    routes,
  })
  
  export default router
